import person_png from '../assets/images/person-icon.png';

export const _ENUMS = {
	// IMAGE: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=4&w=256&h=256&q=60',
	IMAGE: 'https://linguafranca.hr/images/uploads/blank_avatar.png',
	IMAGE_PROFILE: person_png,
};
